import { LocalDate, nativeJs } from "@js-joda/core";

function isExpired(date: Date): boolean {

    const localDate: LocalDate = nativeJs(date).toLocalDate();

    return localDate.isBefore(LocalDate.now());
}

/**
 * Checks if a date is expiring within the number of months provided.
 * If the date is before today it returns false
 * @param date The native JS date
 * @param months The number of months to consider
 * @returns true if the date is between today and today + months
 */
function isExpiring(date: Date, months: number): boolean {
    const localDate: LocalDate = nativeJs(date).toLocalDate();

    if (localDate.isBefore(LocalDate.now()))
        return false;

    return isLocalDateWithinMonths(localDate, months);
}

/**
 * Checks if date is before today + months.
 * @param date The native JS date
 * @param months The number of months to consider
 * @returns true if the date is before today + months
 */
function isDateWithinMonths(date: Date, months: number) {
    const localDate: LocalDate = nativeJs(date).toLocalDate();

    return isLocalDateWithinMonths(localDate, months);
}

export const dateUtils = { isExpired, isExpiring, isDateWithinMonths };

function isLocalDateWithinMonths(localDate: LocalDate, months: number ) {
    const todayPlusMonths = LocalDate.now().plusMonths(months);

    return localDate.isBefore(todayPlusMonths);
}
